import { useVendorSubscriptionFeatures } from '../services/subscriptionService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Backward-compatible wrapper — uses the shared React Query cache (no duplicate fetches).
 * Only vendors hit /vendor/subscription/status (admins/clients would get 403).
 */
const useSubscriptionStatus = () => {
  const { user } = useAuth();
  const isVendor = user?.user_type === 'vendor';

  const {
    hasActiveSubscription,
    isChecking,
    checkSubscriptionStatus,
    refreshSubscriptionStatus,
  } = useVendorSubscriptionFeatures(null, { enabled: isVendor });

  return {
    hasActiveSubscription: isVendor ? hasActiveSubscription : null,
    isChecking: isVendor ? isChecking : false,
    checkSubscriptionStatus,
    refreshSubscriptionStatus,
  };
};

export default useSubscriptionStatus;
